import { useState, useContext, useEffect, useRef } from "react";
import { filterDataContext } from "../../../../App";
import { DEFAULT_CURRENCY } from "../../../../constants";
import QuantityControls from "../../../../components/quantityControls";
import "./index.css";
import { useLocation } from "react-router-dom";
import { formatPrice } from "../../../../utils/func";

const StockQuantity = ({ item, index, reservationData, setReserVationData, showNotifyPopUp, setShowNotifyPopUp, alreadySelectQuantity, ticketName, reserveTicket }) => {
    const [cartQuantity, setCartQuantity] = useState(alreadySelectQuantity || 0);
    const ticketFlags = item?.flags && JSON.parse(item?.flags);
    const { reservationLoader, fetchCartList, setCartData } = useContext(filterDataContext);
    const isFirstRender = useRef(true);
    const includedFlags = JSON.parse(item?.flags)
    const isPairsOnly = includedFlags?.includes("pairs_only");
    const isNoMaxMinus1 = includedFlags?.includes("no_max_minus_1");
    const location = useLocation()
    const checkForCheckoutPage = location.pathname === "/checkout"


    const handleUpdateReserveCart = (quantity) => {
        let updatedReserveData;
        if (quantity > 0) {
            const existingItemIndex = reservationData?.findIndex((data) => data.ticket_id === item.ticket_id);
            if (existingItemIndex !== -1) {
                const updatedData = [...reservationData];
                updatedData[existingItemIndex] = { ...updatedData[existingItemIndex], quantity };
                updatedReserveData = updatedData;
            } else {
                updatedReserveData = [...reservationData, { ticket_id: item.ticket_id, quantity, categoryId: item?.category_id, ticketName, event_id: item?.event_id }];
            }
            setReserVationData(updatedReserveData);
            reserveTicket(updatedReserveData);
        } else {
            updatedReserveData = reservationData.filter((data) => data.ticket_id !== item.ticket_id);
            setReserVationData(updatedReserveData);
            reserveTicket(updatedReserveData);
        }
    };


    const handleIncrease = () => {
        if (reservationData?.length > 0) {
            const { event_id } = reservationData?.[0];
            if (event_id !== item?.event_id) {
                setShowNotifyPopUp(true);
                return;
            }
        }

        let newQuantity = cartQuantity + 1;

        if (isPairsOnly && newQuantity % 2 !== 0) {
            newQuantity += 1;
        }

        if (isNoMaxMinus1 && newQuantity === item.stock - 1) {
            newQuantity = item.stock;
        }

        if (isPairsOnly && isNoMaxMinus1 && newQuantity === item.stock - 1) {
            newQuantity = item.stock % 2 === 0 ? item.stock : item.stock - 2;
        }

        newQuantity = Math.min(newQuantity, item.stock);

        setCartQuantity(newQuantity);
    };

    const handleDecrease = () => {
        let newQuantity = cartQuantity - 1;

        if (isNoMaxMinus1 && newQuantity === item.stock - 1) {
            newQuantity = item.stock - 2;
        }

        if (isPairsOnly && newQuantity % 2 !== 0) {
            newQuantity -= 1;
        }

        if (isPairsOnly && isNoMaxMinus1 && newQuantity === item.stock - 1) {
            newQuantity = item.stock % 2 === 0 ? item.stock - 2 : item.stock - 3;
        }

        newQuantity = Math.max(newQuantity, 0);

        setCartQuantity(newQuantity);
    };



    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        handleUpdateReserveCart(cartQuantity);
    }, [cartQuantity]);

    return (<>

        <div className="radio-group" key={index}>
            <p>
                {`${DEFAULT_CURRENCY} ${formatPrice(item.net_rate_inr)} `}
                <span>{`${item.stock} x`}</span>
            </p>
            <div className="ticket_flags">
                <ul>
                    {ticketFlags && Array.isArray(ticketFlags) && ticketFlags.map((flag, i) => <li key={i}>{flag}</li>)}
                </ul>
            </div>

            <QuantityControls
                disableDecrease={cartQuantity === 0 || reservationLoader || checkForCheckoutPage}
                disableIncrease={cartQuantity === item?.stock || reservationLoader || checkForCheckoutPage}
                showQuantityButtons={!checkForCheckoutPage}
                handleIncrease={() => handleIncrease()}
                cartQuantity={cartQuantity}
                handleDecrease={() => handleDecrease()}
                ticketFlags={ticketFlags}
            />
        </div>
    </>
    );
};

export default StockQuantity;
